export class CookieUtil {

  public static setCookie(name: any, value: any, days: any) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${JSON.stringify(value)};expires=${expires.toUTCString()};path=/`;
  }

  public static getCookie(name: any) {
    const cookieArr = document.cookie.split(';');
    for (let i = 0; i < cookieArr.length; i++) {
      const cookie = cookieArr[i].trim();
      if (cookie.startsWith(name + '=')) {
        return JSON.parse(cookie.substring(name.length + 1));
      }
    }
    return null;
  }

}
